import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class KitService {

  static STEPS = {
    CHOOSE_CLOTHES: 'CHOOSE_CLOTHES',
    JERSEY: 'JERSEY',
    SHORT: 'SHORT', 
    SOCKS: 'SOCKS',
    SUMMARY: 'SUMMARY'
  }

  private kit = {
    jersey: null,
    short: null,
    socks: null,
    noNumber: false,
    noName: false,
    jerseyImages: null,
    colorName: null,
    step: KitService.STEPS.CHOOSE_CLOTHES
  };

  constructor() {}

  public updateJersey(jersey) {
    this.kit["jersey"] = jersey;
  }

  public getJersey() {
    return this.kit["jersey"];
  }

  public updateShort(short) {
    this.kit["short"] = short;
  }

  public getShort() {
    return this.kit["short"];
  }

  public updateSocks(socks) {
    this.kit["socks"] = socks;
  }

  public getSocks() {
    return this.kit["socks"];
  }

  public setColorName(color:string) {
    this.kit.colorName = color;
  }

  public getColorName() {
    return this.kit.colorName;
  }

  public setNoNumber(value: boolean) {
    this.kit.noNumber = value;
  }

  public setNoName(value: boolean) {
    this.kit.noName = value;
  }

  public isNoName() {
    return this.kit.noName;
  }

  public isNoNumber() {
    return this.kit.noNumber;
  }

  public setJerseyImages(jerseyImages) {
    this.kit.jerseyImages = jerseyImages;
  }

  public getJerseyImages() {
    return this.kit.jerseyImages;
  }

  public resetJersey() {
    this.kit.jersey = null;
  }

  public resetShort() {
    this.kit.short = null;
  }

  public resetSocks() {
    this.kit.socks = null;
  }

  public setShortImage(image) {
    if(!this.kit.jerseyImages) {
      this.kit.jerseyImages = {};
    }
    this.kit.jerseyImages['shortImage'] = image;
  }

  public setStep(step) {
    this.kit.step = step;
  }

  public getStep(){
    return this.kit.step;
  }

  public setQuantities(totalJersey, totalShort, totalSocks) {
    this.kit['totalJersey'] = totalJersey;
    this.kit['totalShort'] = totalShort;
    this.kit['totalSocks'] = totalSocks;
  }
 
  public getTotalJersey() {
    return this.kit['totalJersey'];
  }

  public getTotalShort() {
    return this.kit['totalShort'];
  }

  public getTotalSocks() {
    return this.kit['totalSocks'];
  }

  public getJson() {
    return this.kit;
  }

  public setJson(kit) {
    this.kit = kit;
  }
}
